import React, { useState, useEffect } from 'react';

import { Select, Spin } from 'antd';

import { withRouter } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import { searchSlackUsers } from 'components/skills/skills_action';

const { Option } = Select;

function Selectusers(props) {
  //   constructor(props) {
  //     super(props);
  //   }

  const dispatch = useDispatch();
  const [users, setData] = useState([]);
  //   const [value, setValue] = useState();
  const [loading, setloading] = useState(false);
  const [isSelecttion, setSelection] = useState(false);
  const handleSearch = (newValue) => {
    getData(newValue);
  };

  useEffect(() => {
    let isMounted = true;

    if (isSelecttion) {
      setSelection(false);
    } else {
      if (props.defaultUsers) {
        if (props.mode === 'multiple') {
          let data = users.concat(props.defaultUsers);
          //   let user=
          // )
          setData(data);
        } else {
          let data = users.push(props.defaultUsers);
          setData(data);
        }
      }
    }

    return () => {
      isMounted = false;
    };
  }, [props.defaultUsers]);

  const getData = async (newValue) => {
    setloading(true);

    let data = await dispatch(
      searchSlackUsers(props.match.params.wId, newValue, props.type)
    );
    setloading(false);
    if (data.data && data.data.users) {
      setData(data.data.users);
    }
  };

  const onDropdownVisibleChange = async (val) => {
    if (val) {
      setData([]);
      setloading(true);

      dispatch(searchSlackUsers(props.match.params.wId, '', props.type)).then(
        (data) => {
          setloading(false);
          if (data.data && data.data.users) {
            setData(data.data.users);
          }
        }
      );
    }
  };

  const getOptions = () => {
    let checkNameObj = {};
    let options = [];
    let alreadyThere = {};

    users.forEach((mem) => {
      let name, id, user_slack_id, timezone;

      if (!mem) {
        return;
      }

      let slackInfo = mem;
      name = slackInfo
        ? slackInfo.displayName || slackInfo.name || slackInfo.user_name
        : mem.email;
      id = mem.user_id && mem.user_id._id ? mem.user_id._id : mem.user_id;
      user_slack_id = slackInfo.user_slack_id;

      if (checkNameObj[name]) {
        name += ` (${mem.email})`;
      }

      if (!alreadyThere[id]) {
        alreadyThere[id] = true;
        options.push(
          <Option
            key={id}
            value={id}
            user_slack_id={user_slack_id}
            _id={id}
            timezone={timezone}
            displayName={name}
          >
            {name}
          </Option>
        );
      }
    });

    return options;
  };

  const onSelect = (val, event) => {
    setloading(true);
    setSelection(true);
    if (props.onSelect) {
      props.onSelect(val, event);
      dispatch(searchSlackUsers(props.match.params.wId, '')).then((data) => {
        setloading(false);
        if (data.data && data.data.users) {
          setData(data.data.users);
        }
      });
    }
  };

  const onChange = (val, event) => {
    setSelection(true);
    setloading(true);
    if (props.onChange) {
      props.onChange(val);
      dispatch(searchSlackUsers(props.match.params.wId, '', props.type)).then(
        (data) => {
          setloading(false);
          if (data.data && data.data.users) {
            setData(data.data.users);
          }
        }
      );
    }
  };

  return (
    <Select
      showSearch={true}
      allowClear={props.allowClear}
      title={props.title}
      style={props.style}
      mode={props.mode}
      className={props.className || ''}
      onDropdownVisibleChange={onDropdownVisibleChange}
      placeholder={
        props.placeholder
          ? props.placeholder
          : 'Start typing user Display Name ,Email, Name or Slack User Name'
      }
      onChange={onChange}
      onSelect={onSelect}
      onDeselect={props.onDeselect}
      value={props.value ? props.value : undefined}
      disabled={props.disabled}
      notFoundContent={loading ? <Spin size='small' /> : 'No User found'}
      onSearch={handleSearch}
      filterOption={(input, option) => option}
    >
      {getOptions()}
    </Select>
  );
}
export default withRouter(Selectusers);
